/**
 * Generated by orval v6.10.2 🍺
 * Do not edit manually.
 * Frism App API
 * OpenAPI spec version: v1
 */
import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import type {
  UseQueryOptions,
  UseInfiniteQueryOptions,
  QueryFunction,
  UseQueryResult,
  UseInfiniteQueryResult,
  QueryKey,
} from '@tanstack/react-query';
import type {
  ApiResponse,
  FaqResDtoApiResponse,
  GetApiContentsFaqParams,
  GetApiContentsFaqSearchParams,
  GetApiContentsPushContentParams,
  PushContentResDtoApiResponse,
  TermsKindResDtoApiResponse,
  TermsResDtoApiResponse,
  GetApiContentsTermsParams,
  AnnouncementSummaryListDtoApiResponse,
  GetApiContentsAnnouncementParams,
  AnnouncementDtoApiResponse,
  NewAnnouncementCountDtoApiResponse,
  NotificationSummaryListDtoApiResponse,
  NotificationDtoApiResponse,
  GetApiContentsNotificationIdParams,
  NotificationCategoryDtoApiResponse,
} from '../../model';
import { customAxios } from '../../mutator/customAxios';
import type { ErrorType } from '../../mutator/customAxios';

export const getApiContentsSnsTopic = (signal?: AbortSignal) => {
  return customAxios<ApiResponse>({
    url: `/api/contents/sns/topic`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsSnsTopicQueryKey = () => [
  `/api/contents/sns/topic`,
];

export type GetApiContentsSnsTopicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsSnsTopic>>
>;
export type GetApiContentsSnsTopicQueryError = ErrorType<unknown>;

export const useGetApiContentsSnsTopic = <
  TData = Awaited<ReturnType<typeof getApiContentsSnsTopic>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiContentsSnsTopic>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsSnsTopicQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsSnsTopic>>
  > = ({ signal }) => getApiContentsSnsTopic(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsSnsTopic>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const getApiContentsFaq = (
  params?: GetApiContentsFaqParams,
  signal?: AbortSignal,
) => {
  return customAxios<FaqResDtoApiResponse>({
    url: `/api/contents/faq`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiContentsFaqQueryKey = (
  params?: GetApiContentsFaqParams,
) => [`/api/contents/faq`, ...(params ? [params] : [])];

export type GetApiContentsFaqQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsFaq>>
>;
export type GetApiContentsFaqQueryError = ErrorType<unknown>;

export const useGetApiContentsFaq = <
  TData = Awaited<ReturnType<typeof getApiContentsFaq>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiContentsFaqParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiContentsFaq>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsFaqQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsFaq>>
  > = ({ signal }) => getApiContentsFaq(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsFaq>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const getApiContentsFaqSearch = (
  params?: GetApiContentsFaqSearchParams,
  signal?: AbortSignal,
) => {
  return customAxios<FaqResDtoApiResponse>({
    url: `/api/contents/faq/search`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiContentsFaqSearchQueryKey = (
  params?: GetApiContentsFaqSearchParams,
) => [`/api/contents/faq/search`, ...(params ? [params] : [])];

export type GetApiContentsFaqSearchInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsFaqSearch>>
>;
export type GetApiContentsFaqSearchInfiniteQueryError = ErrorType<unknown>;

export const useGetApiContentsFaqSearchInfinite = <
  TData = Awaited<ReturnType<typeof getApiContentsFaqSearch>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiContentsFaqSearchParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getApiContentsFaqSearch>>,
      TError,
      TData
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsFaqSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsFaqSearch>>
  > = ({ signal, pageParam }) =>
    getApiContentsFaqSearch({ offset: pageParam, ...params }, signal);

  const query = useInfiniteQuery<
    Awaited<ReturnType<typeof getApiContentsFaqSearch>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 이용약관 목록 조회
 */
export const getApiContentsTermsList = (signal?: AbortSignal) => {
  return customAxios<TermsKindResDtoApiResponse>({
    url: `/api/contents/terms-list`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsTermsListQueryKey = () => [
  `/api/contents/terms-list`,
];

export type GetApiContentsTermsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsTermsList>>
>;
export type GetApiContentsTermsListQueryError = ErrorType<unknown>;

export const useGetApiContentsTermsList = <
  TData = Awaited<ReturnType<typeof getApiContentsTermsList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiContentsTermsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsTermsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsTermsList>>
  > = ({ signal }) => getApiContentsTermsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsTermsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 이용약관 조회
 */
export const getApiContentsTerms = (
  params?: GetApiContentsTermsParams,
  signal?: AbortSignal,
) => {
  return customAxios<TermsResDtoApiResponse>({
    url: `/api/contents/terms`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiContentsTermsQueryKey = (
  params?: GetApiContentsTermsParams,
) => [`/api/contents/terms`, ...(params ? [params] : [])];

export type GetApiContentsTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsTerms>>
>;
export type GetApiContentsTermsQueryError = ErrorType<unknown>;

export const useGetApiContentsTerms = <
  TData = Awaited<ReturnType<typeof getApiContentsTerms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiContentsTermsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiContentsTerms>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsTermsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsTerms>>
  > = ({ signal }) => getApiContentsTerms(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsTerms>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 유저 공지사항 리스트 (자등으로 마지막 호출 시간을 저장해둔다.)
 */
export const getApiContentsAnnouncement = (
  params?: GetApiContentsAnnouncementParams,
  signal?: AbortSignal,
) => {
  return customAxios<AnnouncementSummaryListDtoApiResponse>({
    url: `/api/contents/announcement`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiContentsAnnouncementQueryKey = (
  params?: GetApiContentsAnnouncementParams,
) => [`/api/contents/announcement`, ...(params ? [params] : [])];

export type GetApiContentsAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsAnnouncement>>
>;
export type GetApiContentsAnnouncementQueryError = ErrorType<unknown>;

export const useGetApiContentsAnnouncement = <
  TData = Awaited<ReturnType<typeof getApiContentsAnnouncement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiContentsAnnouncementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiContentsAnnouncement>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsAnnouncementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsAnnouncement>>
  > = ({ signal }) => getApiContentsAnnouncement(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsAnnouncement>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 유저 공지사항 상세정보
 */
export const getApiContentsAnnouncementId = (
  id: number,
  signal?: AbortSignal,
) => {
  return customAxios<AnnouncementDtoApiResponse>({
    url: `/api/contents/announcement/${id}`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsAnnouncementIdQueryKey = (id: number) => [
  `/api/contents/announcement/${id}`,
];

export type GetApiContentsAnnouncementIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsAnnouncementId>>
>;
export type GetApiContentsAnnouncementIdQueryError = ErrorType<unknown>;

export const useGetApiContentsAnnouncementId = <
  TData = Awaited<ReturnType<typeof getApiContentsAnnouncementId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiContentsAnnouncementId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsAnnouncementIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsAnnouncementId>>
  > = ({ signal }) => getApiContentsAnnouncementId(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsAnnouncementId>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 유저 공지사항 new (레드닷) 갯수
 */
export const getApiContentsAnnouncementNew = (signal?: AbortSignal) => {
  return customAxios<NewAnnouncementCountDtoApiResponse>({
    url: `/api/contents/announcement/new`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsAnnouncementNewQueryKey = () => [
  `/api/contents/announcement/new`,
];

export type GetApiContentsAnnouncementNewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsAnnouncementNew>>
>;
export type GetApiContentsAnnouncementNewQueryError = ErrorType<unknown>;

export const useGetApiContentsAnnouncementNew = <
  TData = Awaited<ReturnType<typeof getApiContentsAnnouncementNew>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiContentsAnnouncementNew>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsAnnouncementNewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsAnnouncementNew>>
  > = ({ signal }) => getApiContentsAnnouncementNew(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsAnnouncementNew>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 유저 알림 리스트 (마지막 호출시간을 저장해둔다)
 */
export const getApiContentsNotification = (signal?: AbortSignal) => {
  return customAxios<NotificationSummaryListDtoApiResponse>({
    url: `/api/contents/notification`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsNotificationQueryKey = () => [
  `/api/contents/notification`,
];

export type GetApiContentsNotificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsNotification>>
>;
export type GetApiContentsNotificationQueryError = ErrorType<unknown>;

export const useGetApiContentsNotification = <
  TData = Awaited<ReturnType<typeof getApiContentsNotification>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiContentsNotification>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsNotificationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsNotification>>
  > = ({ signal }) => getApiContentsNotification(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsNotification>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 알림 상세 정보
 */
export const getApiContentsNotificationId = (
  id: number,
  params?: GetApiContentsNotificationIdParams,
  signal?: AbortSignal,
) => {
  return customAxios<NotificationDtoApiResponse>({
    url: `/api/contents/notification/${id}`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiContentsNotificationIdQueryKey = (
  id: number,
  params?: GetApiContentsNotificationIdParams,
) => [`/api/contents/notification/${id}`, ...(params ? [params] : [])];

export type GetApiContentsNotificationIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsNotificationId>>
>;
export type GetApiContentsNotificationIdQueryError = ErrorType<unknown>;

export const useGetApiContentsNotificationId = <
  TData = Awaited<ReturnType<typeof getApiContentsNotificationId>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetApiContentsNotificationIdParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiContentsNotificationId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiContentsNotificationIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsNotificationId>>
  > = ({ signal }) => getApiContentsNotificationId(id, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsNotificationId>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 유저 알림 new (레드닷) 정보
 */
export const getApiContentsNotificationNew = (signal?: AbortSignal) => {
  return customAxios<NewAnnouncementCountDtoApiResponse>({
    url: `/api/contents/notification/new`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsNotificationNewQueryKey = () => [
  `/api/contents/notification/new`,
];

export type GetApiContentsNotificationNewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsNotificationNew>>
>;
export type GetApiContentsNotificationNewQueryError = ErrorType<unknown>;

export const useGetApiContentsNotificationNew = <
  TData = Awaited<ReturnType<typeof getApiContentsNotificationNew>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiContentsNotificationNew>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsNotificationNewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsNotificationNew>>
  > = ({ signal }) => getApiContentsNotificationNew(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsNotificationNew>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const getApiContentsNotificationCategory = (signal?: AbortSignal) => {
  return customAxios<NotificationCategoryDtoApiResponse>({
    url: `/api/contents/notification/category`,
    method: 'get',
    signal,
  });
};

export const getGetApiContentsNotificationCategoryQueryKey = () => [
  `/api/contents/notification/category`,
];

export type GetApiContentsNotificationCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsNotificationCategory>>
>;
export type GetApiContentsNotificationCategoryQueryError = ErrorType<unknown>;

export const useGetApiContentsNotificationCategory = <
  TData = Awaited<ReturnType<typeof getApiContentsNotificationCategory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiContentsNotificationCategory>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsNotificationCategoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsNotificationCategory>>
  > = ({ signal }) => getApiContentsNotificationCategory(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsNotificationCategory>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * @summary 푸시 콘텐츠 조회
 */
export const getApiContentsPushContent = (
  params?: GetApiContentsPushContentParams,
  signal?: AbortSignal,
) => {
  return customAxios<PushContentResDtoApiResponse>({
    url: `/api/contents/push-content`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetApiContentsPushContentQueryKey = (
  params?: GetApiContentsPushContentParams,
) => [`/api/contents/push-content`, ...(params ? [params] : [])];

export type GetApiContentsPushContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiContentsPushContent>>
>;
export type GetApiContentsPushContentQueryError = ErrorType<unknown>;

export const useGetApiContentsPushContent = <
  TData = Awaited<ReturnType<typeof getApiContentsPushContent>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiContentsPushContentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getApiContentsPushContent>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiContentsPushContentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiContentsPushContent>>
  > = ({ signal }) => getApiContentsPushContent(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getApiContentsPushContent>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};
